import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Link} from "react-router-dom";
import {faArrowAltCircleRight, faArrowAltCircleLeft, faCheckCircle} from '@fortawesome/free-regular-svg-icons';
import {useEffect} from "react";

const iconSize = '5x';


const Footer = ({disable,nextPage}) => {
    useEffect(()=>{
        if(disable){
            document.getElementById("back").style.visibility = "hidden"
        }
        else{
            document.getElementById("back").style.visibility = "visible"
        }
    });
    return(
        <div style={{pointerEvents:"none", zIndex:'1',position:'absolute',left:0,bottom:15,right:0}}>
            <div className={"align-top d-inline-block text-center ms-2"} id='back'>
                <FontAwesomeIcon className={'hover float-start'} style={{pointerEvents:"auto",}} icon={faArrowAltCircleLeft} size={iconSize}/>
                <span className={"d-block FooterText"}>Zurück</span>
            </div>
            <div className={"align-top d-inline-block text-center float-end me-2"}>
                <Link style={{color: "black",textDecoration: "none",pointerEvents:"none"}} className={'hover fa-disabled'} to={nextPage} id={'next'}><FontAwesomeIcon title={nextPage === "/outdoor/exit" ?"Wenn Sie diesen Button drücken, wird der Auftrag abgeschlossen!": nextPage === "/outdoor/traffic" ? "" : "" } icon={nextPage === "/outdoor/exit" ? faCheckCircle:faArrowAltCircleRight} size={iconSize} /></Link>
                {/* <Link style={{color: "black",textDecoration: "none",pointerEvents:"none"}} className={'hover fa-disabled'} to={nextPage} id={'next'}><FontAwesomeIcon title={nextPage === "/outdoor/exit" ?"Wenn Sie diesen Button drücken, wird der Auftrag abgeschlossen!": nextPage === "/outdoor/traffic" ? "Mindestens ein Standort muss ausgewählt sein!" : "" } icon={nextPage === "/outdoor/exit" ? faCheckCircle:faArrowAltCircleRight} size={iconSize} /></Link> */}
                <span className={"d-block FooterText"}>{nextPage === "/outdoor/exit" ?"Abschließen":"Weiter"}</span>
            </div>
        </div>
    )
}

export default Footer;